const INPUT_TYPE_ADDRESS_GROUP = 'AddressGroup';
const INPUT_TYPE_CHECKBOX = 'Checkboxes';
const INPUT_TYPE_COMPANY = 'Company';
const INPUT_TYPE_CREDIT_CARD = 'CreditCard';
const INPUT_TYPE_CURRENCY = 'Currency';
const INPUT_TYPE_DATE = 'Date';
const INPUT_TYPE_DECIMAL = 'Decimal';
const INPUT_TYPE_EMAIL = 'Email';
const INPUT_TYPE_MULTISELECT = 'MultiSelect';
const INPUT_TYPE_NUMBER = 'Number';
const INPUT_TYPE_PHONE = 'Phone';
const INPUT_TYPE_PHONE_GROUP = 'PhoneGroup';
const INPUT_TYPE_RADIO = 'Radio';
const INPUT_TYPE_SELECT = 'Select';
const INPUT_TYPE_TEXT = 'Text';
const INPUT_TYPE_TEXT_AREA = 'TextArea';
const INPUT_TYPE_URL = 'Url';
const INPUT_TYPE_YEAR = 'Year';

const INPUT_TYPE_YESNO = 'YesNo';
const INPUT_TYPE_DAY_OF_WEEK = 'DayOfWeek';
const INPUT_TYPE_NUMBER_DECIMAL = 'NumberDecimal';
const INPUT_TYPE_STATE = 'State';
const INPUT_TYPE_PERCENT = 'Percent';

const FIELD_TYPE_EXTERNAL = 'External';
const FIELD_TYPE_GROUP = 'Group';


const INPUT_OPTIONS_TYPE_COUNTRY = 'Country';
const INPUT_OPTIONS_TYPE_REGION = 'Region';

const STANDARD_GIVEN_NAME_FIELD_ID = 'standard.givenName';
const STANDARD_FAMILY_NAME_FIELD_ID = 'standard.familyName';
const STANDARD_EMAIL1_FIELD_ID = 'standard.emailAddress1';
const STANDARD_PHONE1_FIELD_ID = 'standard.phoneNumber1.value';
const STANDARD_PHONE1_TYPE_FIELD_ID = 'standard.phoneNumber1.type';
const STANDARD_TAG_FIELD_ID = 'standard.tag';
const STANDARD_NOTE_FIELD_ID = 'standard.note';
const STANDARD_BIRTHDAY_FIELD_ID = 'standard.birthDate';
const STANDARD_WEBSITE_FIELD_ID = 'standard.website';

const STANDARD_BILLING_ADDRESS_GROUP_FIELD_ID = 'standard.billingAddressGroup';
const STANDARD_BILLING_LINE1_FIELD_ID = 'standard.billingAddress.streetAddress';
const STANDARD_BILLING_EXTENDED_FIELD_ID = 'standard.billingAddress.extendedAddress';
const STANDARD_BILLING_LOCALITY_FIELD_ID = 'standard.billingAddress.locality';
const STANDARD_BILLING_REGION_FIELD_ID = 'standard.billingAddress.region';
const STANDARD_BILLING_POSTAL_CODE_FIELD_ID = 'standard.billingAddress.postalCode';
const STANDARD_BILLING_COUNTRY_CODE_FIELD_ID = 'standard.billingAddress.countryCode';

const STANDARD_SHIPPING_ADDRESS_GROUP_FIELD_ID = 'standard.shippingAddressGroup';
const STANDARD_SHIPPING_LINE1_FIELD_ID = 'standard.shippingAddress.streetAddress';
const STANDARD_SHIPPING_EXTENDED_FIELD_ID = 'standard.shippingAddress.extendedAddress';
const STANDARD_SHIPPING_LOCALITY_FIELD_ID = 'standard.shippingAddress.locality';
const STANDARD_SHIPPING_REGION_FIELD_ID = 'standard.shippingAddress.region';
const STANDARD_SHIPPING_POSTAL_CODE_FIELD_ID = 'standard.shippingAddress.postalCode';
const STANDARD_SHIPPING_COUNTRY_CODE_FIELD_ID = 'standard.shippingAddress.countryCode';

const STANDARD_OPTIONAL_ADDRESS_GROUP_FIELD_ID = 'standard.optionalAddressGroup';
const STANDARD_OPTIONAL_LINE1_FIELD_ID = 'standard.otherAddress.streetAddress';
const STANDARD_OPTIONAL_EXTENDED_FIELD_ID = 'standard.otherAddress.extendedAddress';
const STANDARD_OPTIONAL_LOCALITY_FIELD_ID = 'standard.otherAddress.locality';
const STANDARD_OPTIONAL_REGION_FIELD_ID = 'standard.otherAddress.region';
const STANDARD_OPTIONAL_POSTAL_CODE_FIELD_ID = 'standard.otherAddress.postalCode';
const STANDARD_OPTIONAL_COUNTRY_CODE_FIELD_ID = 'standard.otherAddress.countryCode';

const BILLING_ADDRESS = 'BillingAddress';
const SHIPPING_ADDRESS = 'ShippingAddress';
const OPTIONAL_ADDRESS = 'OptionalAddress';

const PHONE_1_FIELDS = [
    { id: STANDARD_PHONE1_FIELD_ID, legacyId: 'PHONE1', group: 'PhoneAndEmail', inputType: INPUT_TYPE_PHONE, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: STANDARD_PHONE1_TYPE_FIELD_ID, legacyId: 'PHONE1_TYPE', group: 'PhoneAndEmail', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'PhoneType', fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber1.smsOptin', inputType: INPUT_TYPE_CHECKBOX, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
];

const PHONE_2_FIELDS = [
    { id: 'standard.phoneNumber2.value', legacyId: 'PHONE2', group: 'PhoneAndEmail', inputType: INPUT_TYPE_PHONE, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber2.type', legacyId: 'PHONE2_TYPE', group: 'PhoneAndEmail', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'PhoneType', fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber2.smsOptin', inputType: INPUT_TYPE_CHECKBOX, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
];

const PHONE_3_FIELDS = [
    { id: 'standard.phoneNumber3.value', legacyId: 'PHONE3', group: 'PhoneAndEmail', inputType: INPUT_TYPE_PHONE, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber3.type', legacyId: 'PHONE3_TYPE', group: 'PhoneAndEmail', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'PhoneType', fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber3.smsOptin', inputType: INPUT_TYPE_CHECKBOX, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
];

const PHONE_4_FIELDS = [
    { id: 'standard.phoneNumber4.value', legacyId: 'PHONE4', group: 'PhoneAndEmail', inputType: INPUT_TYPE_PHONE, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber4.type', legacyId: 'PHONE4_TYPE', group: 'PhoneAndEmail', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'PhoneType', fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber4.smsOptin', inputType: INPUT_TYPE_CHECKBOX, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
];

const PHONE_5_FIELDS = [
    { id: 'standard.phoneNumber5.value', legacyId: 'PHONE5', group: 'PhoneAndEmail', inputType: INPUT_TYPE_PHONE, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber5.type', legacyId: 'PHONE5_TYPE', group: 'PhoneAndEmail', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'PhoneType', fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.phoneNumber5.smsOptin', inputType: INPUT_TYPE_CHECKBOX, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
];

const FAX_1_FIELDS = [
    { id: 'standard.faxNumber1.value', legacyId: 'FAX1', group: 'PhoneAndEmail', inputType: INPUT_TYPE_PHONE, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.faxNumber1.type', legacyId: 'FAX1_TYPE', group: 'PhoneAndEmail', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'FaxType', fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
];

const FAX_2_FIELDS = [
    { id: 'standard.faxNumber2.value', legacyId: 'FAX2', group: 'PhoneAndEmail', inputType: INPUT_TYPE_PHONE, fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
    { id: 'standard.faxNumber2.type', legacyId: 'FAX2_TYPE', group: 'PhoneAndEmail', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'FaxType', fieldType: FIELD_TYPE_EXTERNAL, internalOnly: true },
];

const BILLING_ADDRESS_FIELDS = [
    { id: STANDARD_BILLING_LINE1_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'STREET_ADDRESS1', group: BILLING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_BILLING_EXTENDED_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'STREET_ADDRESS2', group: BILLING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_BILLING_LOCALITY_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'CITY', group: BILLING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_BILLING_REGION_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'STATE', group: BILLING_ADDRESS, inputType: INPUT_TYPE_SELECT, inputOptionsType: INPUT_OPTIONS_TYPE_REGION, relatedId: STANDARD_BILLING_COUNTRY_CODE_FIELD_ID, internalOnly: true },
    { id: STANDARD_BILLING_POSTAL_CODE_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'POSTAL_CODE', group: BILLING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_BILLING_COUNTRY_CODE_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'COUNTRY', group: BILLING_ADDRESS, inputType: INPUT_TYPE_SELECT, inputOptionsType: INPUT_OPTIONS_TYPE_COUNTRY, internalOnly: true },
];

const SHIPPING_ADDRESS_FIELDS = [
    { id: STANDARD_SHIPPING_LINE1_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'ADDRESS2_STREET1', group: SHIPPING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_SHIPPING_EXTENDED_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'ADDRESS2_STREET2', group: SHIPPING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_SHIPPING_LOCALITY_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'CITY2', group: SHIPPING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_SHIPPING_REGION_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'STATE2', group: SHIPPING_ADDRESS, inputType: INPUT_TYPE_SELECT, inputOptionsType: INPUT_OPTIONS_TYPE_REGION, relatedId: 'standard.shippingAddress.countryCode', internalOnly: true },
    { id: STANDARD_SHIPPING_POSTAL_CODE_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'POSTAL_CODE2', group: SHIPPING_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_SHIPPING_COUNTRY_CODE_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'COUNTRY2', group: SHIPPING_ADDRESS, inputType: INPUT_TYPE_SELECT, inputOptionsType: INPUT_OPTIONS_TYPE_COUNTRY, internalOnly: true },
];

const OPTIONAL_ADDRESS_FIELDS = [
    { id: STANDARD_OPTIONAL_LINE1_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'ADDRESS3_STREET1', group: OPTIONAL_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_OPTIONAL_EXTENDED_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'ADDRESS3_STREET2', group: OPTIONAL_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_OPTIONAL_LOCALITY_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'CITY3', group: OPTIONAL_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_OPTIONAL_REGION_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'STATE3', group: OPTIONAL_ADDRESS, inputType: INPUT_TYPE_SELECT, inputOptionsType: INPUT_OPTIONS_TYPE_REGION, relatedId: 'standard.otherAddress.countryCode', internalOnly: true },
    { id: STANDARD_OPTIONAL_POSTAL_CODE_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'POSTAL_CODE3', group: OPTIONAL_ADDRESS, inputType: INPUT_TYPE_TEXT, internalOnly: true },
    { id: STANDARD_OPTIONAL_COUNTRY_CODE_FIELD_ID, fieldType: FIELD_TYPE_EXTERNAL, legacyId: 'COUNTRY3', group: OPTIONAL_ADDRESS, inputType: INPUT_TYPE_SELECT, inputOptionsType: INPUT_OPTIONS_TYPE_COUNTRY, internalOnly: true },
];

const BILLING_ADDRESS_GROUP_FIELD = { id: STANDARD_BILLING_ADDRESS_GROUP_FIELD_ID, group: 'Addresses', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_ADDRESS_GROUP, publicOnly: true, childFields: [...BILLING_ADDRESS_FIELDS] };
const SHIPPING_ADDRESS_GROUP_FIELD = { id: STANDARD_SHIPPING_ADDRESS_GROUP_FIELD_ID, group: 'Addresses', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_ADDRESS_GROUP, publicOnly: true, childFields: [...SHIPPING_ADDRESS_FIELDS] };
const OPTIONAL_ADDRESS_GROUP_FIELD = { id: STANDARD_OPTIONAL_ADDRESS_GROUP_FIELD_ID, group: 'Addresses', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_ADDRESS_GROUP, publicOnly: true, childFields: [...OPTIONAL_ADDRESS_FIELDS] };

const ADDRESS_GROUP_FIELDS = [
    BILLING_ADDRESS_GROUP_FIELD,
    SHIPPING_ADDRESS_GROUP_FIELD,
    OPTIONAL_ADDRESS_GROUP_FIELD,
    // these "fake" fields are to help discoverability
    // they are actually the group fields, with `idForLabel` and a different field group
    // `idForLabel` tells it to look up the label from a different ID
    ...BILLING_ADDRESS_FIELDS.slice(1).map((field) => ({ ...BILLING_ADDRESS_GROUP_FIELD, idForLabel: field.id, group: field.group })),
    ...SHIPPING_ADDRESS_FIELDS.slice(1).map((field) => ({ ...SHIPPING_ADDRESS_GROUP_FIELD, idForLabel: field.id, group: field.group })),
    ...OPTIONAL_ADDRESS_FIELDS.slice(1).map((field) => ({ ...OPTIONAL_ADDRESS_GROUP_FIELD, idForLabel: field.id, group: field.group })),
];

export const STANDARD_FIELDS = [
    // General
    { id: STANDARD_GIVEN_NAME_FIELD_ID, legacyId: 'FIRST_NAME', group: 'General', inputType: INPUT_TYPE_TEXT },
    { id: STANDARD_FAMILY_NAME_FIELD_ID, legacyId: 'LAST_NAME', group: 'General', inputType: INPUT_TYPE_TEXT },
    { id: 'standard.jobTitle', legacyId: 'JOB_TITLE', group: 'General', inputType: INPUT_TYPE_TEXT },
    { id: 'standard.owner', legacyId: 'OWNER', group: 'General', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'User', internalOnly: true },
    { id: 'standard.company', legacyId: 'COMPANY', group: 'General', inputType: INPUT_TYPE_COMPANY, inputOptionsType: 'Company', internalOnly: true },
    { id: 'standard.companyName', legacyId: 'COMPANY_NAME', group: 'General', inputType: INPUT_TYPE_TEXT, publicOnly: true },
    { id: 'standard.contactType', legacyId: 'CONTACT_TYPE', group: 'General', inputType: INPUT_TYPE_SELECT, inputOptionsType: 'ContactType', internalOnly: true },
    // Phone and email
    ...PHONE_1_FIELDS,
    ...PHONE_2_FIELDS,
    ...PHONE_3_FIELDS,
    ...PHONE_4_FIELDS,
    ...PHONE_5_FIELDS,
    ...FAX_1_FIELDS,
    ...FAX_2_FIELDS,
    { id: 'standard.phoneGroup1', group: 'PhoneAndEmail', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_PHONE_GROUP, publicOnly: true, childFields: [...PHONE_1_FIELDS] },
    { id: 'standard.phoneGroup2', group: 'PhoneAndEmail', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_PHONE_GROUP, publicOnly: true, childFields: [...PHONE_2_FIELDS] },
    { id: 'standard.phoneGroup3', group: 'PhoneAndEmail', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_PHONE_GROUP, publicOnly: true, childFields: [...PHONE_3_FIELDS] },
    { id: 'standard.phoneGroup4', group: 'PhoneAndEmail', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_PHONE_GROUP, publicOnly: true, childFields: [...PHONE_4_FIELDS] },
    { id: 'standard.phoneGroup5', group: 'PhoneAndEmail', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_PHONE_GROUP, publicOnly: true, childFields: [...PHONE_5_FIELDS] },
    { id: 'standard.faxGroup1', group: 'PhoneAndEmail', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_PHONE_GROUP, publicOnly: true, childFields: [...FAX_1_FIELDS] },
    { id: 'standard.faxGroup2', group: 'PhoneAndEmail', fieldType: FIELD_TYPE_GROUP, inputType: INPUT_TYPE_PHONE_GROUP, publicOnly: true, childFields: [...FAX_2_FIELDS] },
    { id: STANDARD_EMAIL1_FIELD_ID, legacyId: 'EMAIL', group: 'PhoneAndEmail', inputType: INPUT_TYPE_EMAIL },
    { id: 'standard.emailAddress2', legacyId: 'EMAIL_ADDRESS2', group: 'PhoneAndEmail', inputType: INPUT_TYPE_EMAIL },
    { id: 'standard.emailAddress3', legacyId: 'EMAIL_ADDRESS3', group: 'PhoneAndEmail', inputType: INPUT_TYPE_EMAIL },
    // Address
    ...BILLING_ADDRESS_FIELDS,
    ...SHIPPING_ADDRESS_FIELDS,
    ...OPTIONAL_ADDRESS_FIELDS,
    ...ADDRESS_GROUP_FIELDS,
    // Social
    { id: STANDARD_WEBSITE_FIELD_ID, legacyId: 'WEBSITE', group: 'Social', inputType: INPUT_TYPE_URL },
    { id: 'standard.twitter', legacyId: 'TWITTER', group: 'Social', inputType: INPUT_TYPE_URL },
    { id: 'standard.facebook', legacyId: 'FACEBOOK', group: 'Social', inputType: INPUT_TYPE_URL },
    { id: 'standard.linkedIn', legacyId: 'LINKEDIN', group: 'Social', inputType: INPUT_TYPE_URL },
    // Additional
    { id: 'standard.spouseName', legacyId: 'SPOUSE_NAME', group: 'Additional', inputType: INPUT_TYPE_TEXT },
    { id: 'standard.title', legacyId: 'TITLE', group: 'Additional', inputType: INPUT_TYPE_SELECT },
    { id: 'standard.suffix', legacyId: 'SUFFIX', group: 'Additional', inputType: INPUT_TYPE_SELECT, internalOnly: true },
    { id: 'standard.middleName', legacyId: 'MIDDLE_NAME', group: 'Additional', inputType: INPUT_TYPE_TEXT },
    { id: 'standard.preferredName', legacyId: 'NICKNAME', group: 'Additional', inputType: INPUT_TYPE_TEXT },
    { id: STANDARD_BIRTHDAY_FIELD_ID, legacyId: 'BIRTHDAY', group: 'Additional', inputType: INPUT_TYPE_DATE },
    { id: 'standard.anniversary', legacyId: 'ANNIVERSARY', group: 'Additional', inputType: INPUT_TYPE_DATE },
    // Internal
    { id: STANDARD_TAG_FIELD_ID, legacyId: 'FORMS_TAGS', group: 'Internal', inputType: INPUT_TYPE_MULTISELECT, inputOptionsType: 'Tags', internalOnly: true },
    { id: STANDARD_NOTE_FIELD_ID, legacyId: 'FORMS_NOTE', group: 'Internal', inputType: INPUT_TYPE_TEXT_AREA },
];


export const getStandardFields = (i18n) =>
    STANDARD_FIELDS.map((field) => convertKeapStandardFieldToUnlayerField(field, i18n)).filter((field) => !!field);

/**
 * Converts a smartForm/customForm field from definitions in customForm.constants.js to be compatible with unlayer
 *
 * @param {Object} standard field definition from customForm.constants.js/STANDARD_FIELDS
 * @param {Object} i18n localization object provided from consumer
 * @return {UnlayerFormField | null}
 */

const convertKeapStandardFieldToUnlayerField = (standard, i18n) => {
    const fieldId = standard.id || '';

    const label = fieldId.startsWith('standard.') ? i18n.t(`landingPagesCustomForms.fields.${fieldId}`) : i18n.t(`forms.standardFields.${fieldId}`);
    const opts = resolveFieldOptions(i18n)[standard.inputOptionsType] || [];

    const inputType = KEAP_INPUT_TYPE_MAPPING[standard.inputType];

    if (!inputType) {
        return null;
    }

    return {
        name: standard.id,
        label,
        type: inputType,
        options: opts.map((opt) => opt.label || opt.value).filter((opt) => !!opt).join('\n') || '',
        required: true,
        group: i18n.t('landingPagesCustomForms.fieldGroups.ContactFields'),
        show_label: true,
    };
};

export function resolveFieldOptions(i18n) {
    return {
        PhoneType: [
            { value: PHONE_TYPES.WORK, label: i18n.t('global.phones.work') },
            { value: PHONE_TYPES.HOME, label: i18n.t('global.phones.home') },
            { value: PHONE_TYPES.MOBILE, label: i18n.t('global.phones.mobile') },
            { value: PHONE_TYPES.OTHER, label: i18n.t('global.phones.other') },
        ],
        FaxType: [
            { value: PHONE_TYPES.WORK, label: i18n.t('global.phones.work') },
            { value: PHONE_TYPES.HOME, label: i18n.t('global.phones.home') },
            { value: PHONE_TYPES.OTHER, label: i18n.t('global.phones.other') },
        ],
        YesNo: [
            { label: i18n.t('options.notSelected'), value: null },
            { label: i18n.t('global.no'), value: '0' },
            { label: i18n.t('global.yes'), value: '1' },
        ],
        ContactTitle: [
            { value: 'Ms.', label: i18n.t('global.titles.ms') },
            { value: 'Mr.', label: i18n.t('global.titles.mr') },
            { value: 'Mrs.', label: i18n.t('global.titles.mrs') },
            { value: 'Dr.', label: i18n.t('global.titles.dr') },
        ],
    };
}

const UNLAYER_INPUT_TYPES = {
    DROPDOWN: 'dropdown',
    CHECKBOX: 'checkbox',
    BOOLEAN: 'boolean',
    TEXTAREA: 'textarea',
    DATE: 'date',
    NUMBER: 'number',
    RADIO: 'radio',
    TEXT: 'text',
    DATETIME: 'datetime',
    EMAIL: 'email',
    PHONE: 'tel',
};

const KEAP_INPUT_TYPE_MAPPING = {
    [INPUT_TYPE_SELECT]: UNLAYER_INPUT_TYPES.DROPDOWN,
    [INPUT_TYPE_RADIO]: UNLAYER_INPUT_TYPES.RADIO,
    [INPUT_TYPE_CHECKBOX]: UNLAYER_INPUT_TYPES.CHECKBOX,
    [INPUT_TYPE_TEXT]: UNLAYER_INPUT_TYPES.TEXT,
    [INPUT_TYPE_TEXT_AREA]: UNLAYER_INPUT_TYPES.TEXTAREA,
    [INPUT_TYPE_DATE]: UNLAYER_INPUT_TYPES.DATE,
    [INPUT_TYPE_CURRENCY]: UNLAYER_INPUT_TYPES.NUMBER,
    [INPUT_TYPE_DECIMAL]: UNLAYER_INPUT_TYPES.NUMBER,
    [INPUT_TYPE_EMAIL]: UNLAYER_INPUT_TYPES.EMAIL,
    [INPUT_TYPE_MULTISELECT]: UNLAYER_INPUT_TYPES.CHECKBOX,
    [INPUT_TYPE_NUMBER]: UNLAYER_INPUT_TYPES.NUMBER,
    [INPUT_TYPE_PHONE]: UNLAYER_INPUT_TYPES.PHONE,
    [INPUT_TYPE_URL]: UNLAYER_INPUT_TYPES.TEXT,
    [INPUT_TYPE_YEAR]: UNLAYER_INPUT_TYPES.NUMBER,
    [INPUT_TYPE_YESNO]: UNLAYER_INPUT_TYPES.BOOLEAN,
    [INPUT_TYPE_NUMBER_DECIMAL]: UNLAYER_INPUT_TYPES.NUMBER,
    [INPUT_TYPE_PERCENT]: UNLAYER_INPUT_TYPES.NUMBER,
    // todo Implement all these
    [INPUT_OPTIONS_TYPE_COUNTRY]: null, // should be dropdown but we don't have it working in unlayer
    [INPUT_TYPE_CREDIT_CARD]: null,
    [INPUT_TYPE_DAY_OF_WEEK]: null,
    [INPUT_TYPE_STATE]: null,
    [INPUT_TYPE_COMPANY]: null,
    [INPUT_TYPE_PHONE_GROUP]: null,
    [INPUT_TYPE_ADDRESS_GROUP]: null,
};


const PHONE_TYPES = {
    HOME: 'HOME',
    MOBILE: 'MOBILE',
    WORK: 'WORK',
    OTHER: 'OTHER',
};
